import {
    deliveryModeId,
    onlineNatureId,
    detailLocations,
} from '../shared/programRequestDetailsModel';

export const createSplitProgramModel = () => ({
    institutionId: null,
    sourceProgramId: null,
    comments: '',
});

export const createSplitProgramEditModel = details => ({
    institutionId: details?.institutionId ?? null,
    sourceProgramId: Number(details?.programID ?? details?.programId) || null,
    comments: '',
});

export const splitProgramFromDetails = details => ({
    requestId: details?.requestID ?? details?.requestId,
    programName: details?.programName ?? '',
    cipCode: details?.cipCode ?? null,
    degreeLevel: details?.degreeLevelId ?? null,
    deliveryMode: deliveryModeId(details?.deliveryMode),
    onlineNature: onlineNatureId(details?.deliveryModeOnline),
    creditMin: details?.creditRequirementMinimum ?? '',
    creditMax: details?.creditRequirementMaximum ?? '',
    locations: detailLocations(details),
});

const toDeliveryModeId = deliveryMode =>
    deliveryMode === null || deliveryMode === undefined || deliveryMode === ''
        ? null
        : Number(deliveryMode);

const toOnlineNatureId = program => {
    const modeId = toDeliveryModeId(program.deliveryMode);
    if (modeId === 3) return Number(program.onlineNature ?? 0);
    return modeId === 1 ? 0 : 1;
};

export const toCreateSplitRequest = (form, newPrograms) => ({
    institutionId: form.institutionId,
    sourceProgramId: form.sourceProgramId,
    newPrograms: newPrograms.map(program => ({
        formalName: program.programName.trim(),
        cipCode: program.cipCode,
        degreeLevel: program.degreeLevel || null,
        distanceEdApproved: { id: toDeliveryModeId(program.deliveryMode) },
        distanceEdOnline: {
            id: toOnlineNatureId(program),
        },
        creditRequirementMinimum:
            program.creditMin !== '' ? Number(program.creditMin) : null,
        creditRequirementMaximum:
            program.creditMax !== '' ? Number(program.creditMax) : null,
    })),
    comments: form.comments || null,
});

export const toEditSplitChildRequest = program => ({
    requestId: program.requestId,
    formalName: program.programName.trim(),
    cipCode: program.cipCode,
    degreeLevel: program.degreeLevel || null,
    distanceEdApproved: { id: toDeliveryModeId(program.deliveryMode) },
    distanceEdOnline: { id: toOnlineNatureId(program) },
    creditRequirementMinimum:
        program.creditMin !== '' ? Number(program.creditMin) : null,
    creditRequirementMaximum:
        program.creditMax !== '' ? Number(program.creditMax) : null,
    locationStatusChanges: (program.locations ?? []).map(location => ({
        locationId: location.value,
        statusId: Number(location.statusId ?? 1),
    })),
});

export const toEditSplitRequest = (form, newPrograms, details) => ({
    requestId: details?.requestID ?? details?.requestId,
    institutionId: form.institutionId,
    sourceProgramId: form.sourceProgramId,
    newPrograms: newPrograms.map(toEditSplitChildRequest),
    comments: form.comments || null,
});
